import firebase from "../../config/firebase";
import { toast } from "react-toastify";

export const updateTable = (payload) => async (dispatch) => {
  await dispatch({ type: "TABLE_UPDATE", payload: payload });
};

export const getTableData = (restaurantID) => (dispatch) => {
  try {
    const restaurantRef = firebase
      .firestore()
      .collection("table")
      .doc(restaurantID);
    const unsubscribe = restaurantRef.onSnapshot((restaurantDoc) => {
      if (!restaurantDoc.exists) {
        return;
      }

      const restaurantData = restaurantDoc.data();
      if (!restaurantData) {
        return;
      }

      const { timer, totalTables } = restaurantData;

      const tablesRef = restaurantRef.collection("tables");

      tablesRef.onSnapshot((allTablesSnapshot) => {
        const allTablesData = {};
        allTablesSnapshot.forEach((doc) => {
          allTablesData[doc.id] = { id: doc.id, ...doc.data() };
        });
        dispatch({
          type: "FETCH_ALL_TABLES_SUCCESS",
          payload: {
            timer,
            totalTables,
            allTables: allTablesData,
          },
        });
      });
    });

    return unsubscribe;
  } catch (error) {
    console.error("Error fetching tables:", error);
    toast.error(error.message);
  }
};
export const setEndLoading = (tableId, loading) => ({
  type: "END_LOADING",
  payload: { tableId, loading },
});

export const EndTime = (restaurantID, tableId) => async (dispatch) => {
  try {
    dispatch(setEndLoading(tableId, true));

    const db = firebase.firestore();
    const tableRef = db
      .collection("table")
      .doc(restaurantID)
      .collection("tables")
      .doc(tableId);

    await tableRef.update({
      customerId: null,
      occupiedAt: null,
      expireAt: null,
    });

    toast.success("Table Time Ended Successfully");
  } catch (error) {
    console.error(`Error updating table ${tableId}:`, error);
    toast.error("Failed to update table");
  } finally {
    dispatch(setEndLoading(tableId, false));
  }
};

export const setExtendLoading = (tableId, loading) => ({
  type: "EXTEND_LOADING",
  payload: { tableId, loading },
});

export const ExtendTime =
  (restaurantID, tableId, timer) => async (dispatch) => {
    try {
      dispatch(setExtendLoading(tableId, true));

      const db = firebase.firestore();
      const tableRef = db
        .collection("table")
        .doc(restaurantID)
        .collection("tables")
        .doc(tableId);

      const [value, unit] = timer.split(" ");
      const duration = Number(value);
      let expirationTimestamp = firebase.firestore.Timestamp.now();

      if (unit === "Min") {
        expirationTimestamp = firebase.firestore.Timestamp.fromMillis(
          expirationTimestamp.toMillis() + duration * 60 * 1000
        );
      } else if (unit === "Hour") {
        expirationTimestamp = firebase.firestore.Timestamp.fromMillis(
          expirationTimestamp.toMillis() + duration * 60 * 60 * 1000
        );
      }
      await tableRef.update({
        expireAt: expirationTimestamp,
      });
      toast.success("Table Time Extended Successfully");
    } catch (error) {
      console.error(`Error updating table ${tableId}:`, error);
      toast.error("Failed to update table");
    } finally {
      dispatch(setExtendLoading(tableId, false));
    }
  };

export const updateTableData =
  (restaurantID, customerID, tableNo, timer) => async () => {
    try {
      if (!timer || !customerID) return;

      const db = firebase.firestore();
      const restaurantRef = db.collection("table").doc(restaurantID);
      const tablesRef = restaurantRef.collection("tables");
      const tableNumber = Number(tableNo);
      const querySnapshot = await tablesRef
        .where("tableNo", "==", tableNumber)
        .get();

      if (querySnapshot.empty) {
        return;
      }
      const tableDoc = querySnapshot.docs[0];
      if (!tableDoc.exists) {
        return;
      }

      const [value, unit] = timer.split(" ");
      const duration = Number(value);
      let expirationTimestamp = firebase.firestore.Timestamp.now();

      if (unit === "Min") {
        expirationTimestamp = firebase.firestore.Timestamp.fromMillis(
          expirationTimestamp.toMillis() + duration * 60 * 1000
        );
      } else if (unit === "Hour") {
        expirationTimestamp = firebase.firestore.Timestamp.fromMillis(
          expirationTimestamp.toMillis() + duration * 60 * 60 * 1000
        );
      }

      await tableDoc.ref.update({
        customerId: customerID,
        occupiedAt: firebase.firestore.FieldValue.serverTimestamp(),
        expireAt: expirationTimestamp,
      });
    } catch (error) {
      console.error("Error occupying table:", error);
      toast.error(error.message || "Failed to occupy table.");
    }
  };

export const clearTableData = (restaurantID, tableNo) => async () => {
  try {
    const db = firebase.firestore();
    const restaurantRef = db.collection("table").doc(restaurantID);
    const tablesRef = restaurantRef.collection("tables");
    const tableNumber = Number(tableNo);

    const querySnapshot = await tablesRef
      .where("tableNo", "==", tableNumber)
      .get();

    if (querySnapshot.empty) {
      return;
    }

    const tableDoc = querySnapshot.docs[0];
    if (!tableDoc.exists) {
      return;
    }

    await tableDoc.ref.update({
      customerId: null,
      expireAt: null,
      occupiedAt: null,
    });
  } catch (error) {
    console.error("Error clearing table data:", error);
    toast.error(error.message || "Failed to clear table.");
  }
};


export const tableTimeEnd = (restaurantID, tableNo) => async () => {
  try {
    const db = firebase.firestore();
    const restaurantRef = db.collection("table").doc(restaurantID);
    const tablesRef = restaurantRef.collection("tables");
    const tableNumber = Number(tableNo);
    const querySnapshot = await tablesRef
      .where("tableNo", "==", tableNumber)
      .get();
    if (querySnapshot.empty) return;
    const tableDoc = querySnapshot.docs[0];
    if (!tableDoc.exists) return;

    await tableDoc.ref.update({
      customerId: null,
      occupiedAt: null,
      expireAt: null,
    });
    toast.success(`Reservation of table ${tableNumber} has ended.`);
  } catch (error) {
    console.error("Error releasing table:", error);
    toast.error(error.message || "Failed to release table.");
  }
};
